import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "as-h2h as-scrolling as-scrolling__result-popup"
}

import { ref, computed } from "vue";
import type { IMatch, IMatchLiveData } from "~src/interfaces/basketball";
import MatchItem from "~src/components/matches/basketball/MatchItem.vue";
import MatchEnum from "~src/enums/basketball/MatchEnum";
import NoData from "~src/components/NoData.vue";
import TabsBtn from "~src/components/TabsBtn.vue";


const __default__ = {};

interface IProps {
  matchLiveData: IMatchLiveData;
  matchId: string;
  mode?: string;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'MatchOther',
  props: {
    matchLiveData: {},
    matchId: {},
    mode: {}
  },
  setup(__props: any) {

const props = __props;

const activeTab = ref("all");

const tabs = [
  {
    title: "Tất cả trận",
    key: "all",
  },
  {
    title: "Có bàn thắng",
    key: "goal",
  },
  {
    title: "Chưa bàn thắng",
    key: "no_goal",
  },
  {
    title: "H1",
    key: "h1",
  },
  {
    title: "H2",
    key: "h2",
  },
  {
    title: "H3",
    key: "h3",
  },
  {
    title: "H4",
    key: "h4",
  },
  {
    title: "OT",
    key: "ot",
  },
];

const matches = computed(() => {
  return props.matchLiveData.matches.filter((match: IMatch) => {
    if (
      match.id === props.matchId ||
      match.status_id === MatchEnum.STATUS_END
    ) {
      return false;
    }

    if (activeTab.value === "all") {
      return true;
    }

    if (!MatchEnum.LIST_STATUS_PLAYING.includes(match.status_id)) {
      return false;
    }

    if (activeTab.value === "goal") {
      if (match.home_scores[0] != 0 || match.away_scores[0] != 0) {
        return true;
      }

      return false;
    } else if (activeTab.value === "no_goal") {
      if (match.home_scores[0] == 0 && match.away_scores[0] == 0) {
        return true;
      }

      return false;
    } else if (activeTab.value === "h1") {
      if (match.status_id === MatchEnum.STATUS_SECTION_ONE) {
        return true;
      }

      return false;
    } else if (activeTab.value === "h2") {
      if (match.status_id === MatchEnum.STATUS_SECTION_TWO) {
        return true;
      }

      return false;
    } else if (activeTab.value === "h3") {
      if (match.status_id === MatchEnum.STATUS_SECTION_THREE) {
        return true;
      }

      return false;
    } else if (activeTab.value === "h4") {
      if (match.status_id === MatchEnum.STATUS_SECTION_FOUR) {
        return true;
      }

      return false;
    } else if (activeTab.value === "ot") {
      if (match.status_id === MatchEnum.STATUS_OVERTIME) {
        return true;
      }

      return false;
    }

    return true;
  });
});

const wait = async (ms: number) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

const changeTab = async (tab: string) => {
  activeTab.value = tab;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TabsBtn, {
      tabs: tabs,
      activeTab: activeTab.value,
      onChange: changeTab,
      isShowBorder: true
    }, null, 8, ["activeTab"]),
    (matches.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(), _createElementBlock("div", {
            class: "as-match-list as-mt-12",
            key: activeTab.value
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(matches.value, (item, key) => {
              return (_openBlock(), _createBlock(MatchItem, {
                key: key,
                match: item,
                teams: _ctx.matchLiveData.teams,
                competitions: _ctx.matchLiveData.competitions,
                commentators: _ctx.matchLiveData.commentators,
                isShowFlagHalf: false,
                mode: _ctx.mode
              }, null, 8, ["match", "teams", "competitions", "commentators", "mode"]))
            }), 128))
          ]))
        ]))
      : (_openBlock(), _createBlock(NoData, { key: 1 }))
  ], 64))
}
}

})